export default "__VITE_ASSET__950fc608__"